import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import axiosInstance from 'config/axiosConfig';

async function downloadCSV() {
    try {
        const { data } = await axiosInstance.get(`/inquires/download-csv`);
        return data.data.url as string;
    } catch (error) {
        if (axios.isAxiosError(error)) throw new Error(error.response?.data.message);
        throw new Error(error as string);
    }
}

export const useDownloadCsvLeads = () => {
    return useMutation({
        mutationFn: downloadCSV,
        onSuccess: (url: string) => window.open(url),
    });
};
